import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Toolbar,
    Typography,
} from "@material-ui/core"
import {
    Add,
    Check,
    CheckBox,
    CheckBoxOutlineBlank,
    Close,
    Delete,
    Print,
    Settings,
} from "@material-ui/icons"
import { useEffect, useState } from "react"

import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition"
import { useHistory } from "react-router-dom"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { textoHTML } from "../../../services/functionsGerais"
import {
    BuscarFormaDePagamentos,
    FecharMesa,
    MudarNumeroMesa,
    salvarMesaParcial,
} from "../../../services/integracao"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import SelecaoFormaPagamento from "../../components/SelecaoFormaPagamento"
import CardPedido from "./CardPedido"
import DialogConfiguracoes from "./DialogConfiguracoes"

const qz = require("qz-tray")

function CabecalhoMesa({ classes, mesa, handleClose }) {
    const valorTotal = mesa?.pedidosMesa?.reduce((total, pedido) => total + pedido?.valorTotal, 0)
    const valorFormatado = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Math.abs(valorTotal) < 0.01 ? 0 : valorTotal || 0)

    return (
        <div className={classes.containerCabecalho}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <div className={classes.numeroDaMesa}>
                        <div>
                            <IconButton color="inherit" onClick={handleClose} aria-label="close">
                                <Close />
                            </IconButton>
                            <Typography
                                variant="h6"
                                component="span"
                                style={{ marginRight: "1em" }}
                            >
                                Mesa {mesa?.numeroMesa}
                            </Typography>
                        </div>
                        <Typography
                            variant="h6"
                            component="span"
                            className={classes.valorFortmatado}
                        >
                            R${valorFormatado}
                        </Typography>
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    )
}

const MeioDePagamento = ({
    index,
    formasDePagamento,
    setFormasDePagamento,
    setValorRestante,
    opcoesDePagamento,
    classes,
    formaDePagamento,
    valorTotal,
    descontoManual,
    handleExcluirFormaDePagamento,
}) => {
    const handleMeioPagamento = e => {
        const novoMeio = e?.id

        setFormasDePagamento(prev => {
            const novasFormas = [...prev]
            novasFormas[index] = {
                ...novasFormas[index],
                formaPagamento: { id: novoMeio },
                id: null,
                versao: 0,
            }
            return novasFormas
        })
    }

    const handleValor = e => {
        const valorDigitado = e.target.value.replace(",", ".")
        const novasFormas = [...formasDePagamento]
        novasFormas[index].valor = valorDigitado
        novasFormas[index].valorCentavos = valorDigitado * 100
        setFormasDePagamento(novasFormas)

        setValorRestante(
            valorTotal -
                formasDePagamento?.reduce(
                    (total, item) => total + parseFloat(item?.valor || 0),
                    0
                ) -
                descontoManual
        )
    }

    return (
        <Grid container className={classes.containerDePagamento} style={{ marginBottom: "0.5em" }}>
            <Grid item className={classes.selecaoFormaDePagamento}>
                <SelecaoFormaPagamento
                    formasPagamento={opcoesDePagamento}
                    handleSelecaoFormaDePagamento={handleMeioPagamento}
                    formaDePagamento={formaDePagamento}
                    mesa={true}
                />
            </Grid>
            <Grid item style={{ flex: 1 }}>
                <TextField
                    label="Valor (R$)"
                    fullWidth
                    variant="outlined"
                    placeholder="R$ 00,00"
                    value={String(formaDePagamento.valor).replace(".", ",")}
                    onChange={handleValor}
                />
            </Grid>
            <IconButton
                size="small"
                onClick={() => {
                    handleExcluirFormaDePagamento(index)
                }}
                className={classes.excluirFormaDePagamento}
            >
                <Delete />
            </IconButton>
        </Grid>
    )
}

const DialogFinalizarMesa = ({
    mesa,
    openFinalizarMesa,
    setOpenFinalizarMesa,
    Transition,
    alertStart,
    useStyles,
    opcoesDePagamento,
}) => {
    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    const classes = useStyles()
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const taxaAdicionalSalva = localStorage.getItem("taxaAdicionalMesa") || 0
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const [taxaAdicional, setTaxaAdicional] = useState(
        localStorage.getItem("taxaAdicionalMesa") || 0
    )

    const [descontoManual, setDescontoManual] = useState(0)

    const valorTotalPrevio = mesa?.pedidosMesa?.reduce(
        (total, pedido) => total + pedido.valorTotal,
        0
    )

    const valorTotal = Number(
        valorTotalPrevio + (valorTotalPrevio * Number(taxaAdicionalSalva)) / 100
    )

    const fomrasDePagamentosSalvas = []

    if (mesa?.pagamentos) {
        fomrasDePagamentosSalvas.push(mesa.pagamentos.map(pagamento => pagamento))
    }

    const valorSalvoParcial =
        fomrasDePagamentosSalvas.length > 0
            ? fomrasDePagamentosSalvas[0].reduce((acumulador, forma) => acumulador + forma.valor, 0)
            : 0

    const [valorRestante, setValorRestante] = useState(0)

    const [formasDePagamento, setFormasDePagamento] = useState(
        fomrasDePagamentosSalvas?.length > 0
            ? fomrasDePagamentosSalvas[0].concat({
                  valor: (valorTotal - valorSalvoParcial).toFixed(2) || 0,
                  valorCentavos: Math.round((valorTotal - valorSalvoParcial) * 100) || 0,
              })
            : [
                  {
                      valorCentavos:
                          Math.round(valorTotalPrevio + valorTotalPrevio * (taxaAdicional / 100)) ||
                          0,
                      valor:
                          (valorTotalPrevio + valorTotalPrevio * (taxaAdicional / 100)).toFixed(
                              2
                          ) || 0,
                  },
              ]
    )

    const valorFormatado = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Math.abs(valorRestante) < 0.01 ? 0 : valorRestante || 0)

    const handleClose = () => setOpenFinalizarMesa(false)

    const handleAdicionarFormaDePagamento = () => {
        setFormasDePagamento(prev => [...prev, { valor: 0 }])
    }

    const handleExcluirFormaDePagamento = i => {
        let valorVoltar
        setFormasDePagamento(prev => {
            const formasAtualizadas = [...prev]
            valorVoltar = formasAtualizadas.splice(i, 1)

            return formasAtualizadas
        })
        setValorRestante(prev => (prev += Number(valorVoltar[0].valor)))
    }

    const handleTaxaAdicional = e => {
        const valorDigitado = e?.target?.value.replace(",", ".")
        localStorage.setItem("taxaAdicionalMesa", valorDigitado)
        setTaxaAdicional(valorDigitado)
        setFormasDePagamento(
            fomrasDePagamentosSalvas?.length > 0
                ? fomrasDePagamentosSalvas[0].concat({
                      valor: 0,
                  })
                : [{ valor: 0 }]
        )
        setValorRestante(
            valorTotalPrevio +
                valorTotalPrevio * (valorDigitado / 100) -
                descontoManual -
                valorSalvoParcial
        )
    }

    const handleDescontoManual = e => {
        const valorDigitado = e.target.value.replace(",", ".")
        setDescontoManual(valorDigitado)
        setFormasDePagamento(
            fomrasDePagamentosSalvas?.length > 0
                ? fomrasDePagamentosSalvas[0].concat({
                      valor: 0,
                  })
                : [{ valor: 0 }]
        )
        setValorRestante(
            valorTotalPrevio +
                valorTotalPrevio * (taxaAdicional / 100) -
                valorDigitado -
                valorSalvoParcial
        )
    }

    const handleSalvarMesaParcial = async (mesa, imprimir) => {
        try {
            setLoading(true)
            const response = await salvarMesaParcial(mesa, autorizacao)

            if (imprimir) {
                mandarImprimir({ texto: response.impressao })
                return
            }
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            alertStart(`Valor parcial salvo na mesa: ${mesa.numeroMesa}`, "success")
            setOpenFinalizarMesa(false)
        } catch (error) {
            RegistrarLogErro(error, "fecharPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    const fecharPedidoMesa = async mesa => {
        try {
            setLoading(true)
            const response = await FecharMesa(mesa, autorizacao)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                setLoading(false)
                return false
            }
            alertStart(`Mesa ${mesa.numeroMesa} fechada com sucesso!`, "success")
            window.location.reload()
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "fecharPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleFecharMesa = async (salvarParcial, imprimir) => {
        mesa.valorAdicional = Number((valorTotalPrevio * (taxaAdicional / 100)).toFixed(2))
        mesa.valorDesconto = Number(descontoManual)
        if (imprimir) {
            handleSalvarMesaParcial(mesa, imprimir)
            return
        }
        try {
            if (formasDePagamento.length === 0) {
                throw new Error("Adicione uma forma de pagamento")
            }
            const formasDePagamentoFiltradas = formasDePagamento.filter(
                obj => Object.keys(obj).length !== 0
            )
            formasDePagamentoFiltradas.forEach(forma => {
                if (!forma.formaPagamento) {
                    throw new Error("Preencha todas as formas de pagamento")
                }
            })
            mesa.pagamentos = formasDePagamentoFiltradas
            mesa.pagamentos.forEach(pagamento => (pagamento.valor = parseFloat(pagamento.valor)))
            if (salvarParcial) {
                handleSalvarMesaParcial(mesa, imprimir)
                return
            }
            if (
                (valorRestante ?? 0)?.toFixed(2) === "0.00" ||
                (valorRestante ?? 0)?.toFixed(2) === "-0.00"
            ) {
                await fecharPedidoMesa(mesa)
            } else {
                alertStart("O valor restante deve ser igual a zero para fechar a mesa", "warning")
            }
        } catch (err) {
            alertStart(err.message, "warning")
        }
    }

    return (
        <Dialog
            open={openFinalizarMesa}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            fullScreen={mobile}
        >
            <DialogTitle>{`Fechar Mesa ${mesa?.numeroMesa}`}</DialogTitle>
            <DialogContent className={classes.listaPedidos}>
                <div className={classes.listaPedidos}>
                    <Grid container style={{ flexDirection: "column" }}>
                        <Grid container spacing={1}>
                            <Grid item container>
                                <TextField
                                    disabled
                                    label="Subtotal (R$)"
                                    fullWidth
                                    variant="outlined"
                                    value={Number(valorTotalPrevio)?.toFixed(2).replace(".", ",")}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                            </Grid>
                            <Grid item container justifyContent="space-between">
                                <TextField
                                    style={{ width: "49%" }}
                                    label="Taxa de Serviço"
                                    variant="outlined"
                                    value={String(taxaAdicional)?.replace(".", ",")}
                                    onChange={handleTaxaAdicional}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">%</InputAdornment>
                                        ),
                                    }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                                <TextField
                                    style={{ width: "49%" }}
                                    disabled
                                    label="Taxa de Serviço (R$)"
                                    variant="outlined"
                                    value={Number(valorTotalPrevio * (taxaAdicional / 100))
                                        ?.toFixed(2)
                                        .replace(".", ",")}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                            </Grid>
                            <Grid item container>
                                <TextField
                                    label="Desconto Manual (R$)"
                                    fullWidth
                                    variant="outlined"
                                    value={String(descontoManual)?.replace(".", ",")}
                                    onChange={handleDescontoManual}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                    }}
                                />
                            </Grid>
                            <Grid item container style={{ justifyContent: "end" }}>
                                <Typography variant="h5">
                                    Total: R${" "}
                                    {Number(
                                        valorTotalPrevio +
                                            valorTotalPrevio * (taxaAdicional / 100) -
                                            descontoManual
                                    )
                                        ?.toFixed(2)
                                        .replace(".", ",")}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={1} style={{ marginTop: "0.5em" }}>
                            <Grid item container>
                                {formasDePagamento?.map((formaDePagamento, index) => (
                                    <MeioDePagamento
                                        key={index}
                                        index={index}
                                        formasDePagamento={formasDePagamento}
                                        setFormasDePagamento={setFormasDePagamento}
                                        setValorRestante={setValorRestante}
                                        opcoesDePagamento={opcoesDePagamento}
                                        classes={classes}
                                        formaDePagamento={formaDePagamento}
                                        valorTotal={valorTotal}
                                        descontoManual={descontoManual}
                                        handleExcluirFormaDePagamento={
                                            handleExcluirFormaDePagamento
                                        }
                                    />
                                ))}
                            </Grid>
                            <Grid item container style={{ justifyContent: "end" }}>
                                <Typography variant="body1">
                                    Valor Restante: R$ {valorFormatado}
                                </Typography>
                            </Grid>
                            <Grid item container>
                                <Button
                                    color="primary"
                                    onClick={handleAdicionarFormaDePagamento}
                                    variant="contained"
                                    fullWidth
                                    disabled={
                                        Number(valorRestante)?.toFixed(2) == 0.0 ? true : false
                                    }
                                >
                                    Adicionar forma de pagamento
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1}>
                    <Grid
                        item
                        container
                        xs={12}
                        sm={6}
                        style={{ display: "flex", justifyContent: "space-between" }}
                    >
                        <Button className={classes.botaoFecharMesa} onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button
                            className={classes.botaoFecharParcial}
                            style={{ backgroundColor: "#007bff" }}
                            onClick={() => handleFecharMesa(true, true)}
                        >
                            <Typography>
                                <Print /> imprimir
                            </Typography>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        sm={6}
                        style={{ display: "flex", justifyContent: "space-between" }}
                    >
                        <Button
                            className={classes.botaoFecharParcial}
                            onClick={() => {
                                handleFecharMesa(true)
                            }}
                        >
                            Fechar parcial
                        </Button>
                        <Button
                            className={classes.botaoFecharMesa}
                            onClick={() => {
                                handleFecharMesa()
                            }}
                        >
                            Fechar Mesa
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

const LIMITE_NUMERO_IMPRESSORAS = 10

function getImpressoras(configuracoes) {
    if (configuracoes.printer.impressoras?.length) return configuracoes.printer.impressoras

    return []
}

const ListaImpressorasSelecionadas = ({ tipoPainelImpressao, impressorasQZ }) => {
    const classes = useStyles()

    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const [listaImpressoras, setListaImpressoras] = useState(getImpressoras(configuracoes))

    const [isImprimirComandaCompleta, setIsImprimirComandaCompleta] = useState(
        configuracoes?.printer?.imprimirComandaCompleta ?? false
    )
    const [impressoraComandaCompleta, setImpressoraComandaCompleta] = useState(
        configuracoes.printer.impressoraComandaCompleta ?? "Nenhuma"
    )

    const handleChangeImpressora = (e, i) => {
        listaImpressoras[i] = e.target.value

        const impressorasFiltradas = listaImpressoras.filter(
            i => i && impressorasQZ.find(nomeImpressora => nomeImpressora === i)
        )

        setListaImpressoras(impressorasFiltradas)

        atualizarConfiguracoes({
            printer: {
                impressoras: impressorasFiltradas,
                imprimirComandaCompleta: isImprimirComandaCompleta,
                impressoraComandaCompleta:
                    impressoraComandaCompleta !== "Nenhuma" ? impressoraComandaCompleta : null,
            },
        })
    }

    if (tipoPainelImpressao !== "plugin") return null

    const adicionarImpressora = () => setListaImpressoras(prev => [...prev, "Nenhuma"])

    return (
        <>
            {listaImpressoras?.map((impressora, i) => (
                <Grid item xs={12} md={6} lg={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel id="impressoras">{`Imprimir ${i + 1}º Opção`}</InputLabel>
                        <Select
                            fullWidth
                            value={impressora}
                            onChange={e => handleChangeImpressora(e, i)}
                            label={`Imprimir ${i + 1}º Opção`}
                        >
                            <MenuItem value="Nenhuma">Nenhuma</MenuItem>
                            {impressorasQZ.map((printer, index) => (
                                <MenuItem key={index} value={printer}>
                                    {printer}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            ))}
            {listaImpressoras.length < LIMITE_NUMERO_IMPRESSORAS ? (
                <Grid item xs={12} md={6} lg={6}>
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={adicionarImpressora}
                        className={classes.adicionarImpressora}
                    >
                        Adicionar Impressora
                    </Button>
                </Grid>
            ) : null}
            {configuracoes?.user?.parametros?.impressaoAlternada ? (
                <>
                    <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isImprimirComandaCompleta}
                                    onChange={e => setIsImprimirComandaCompleta(e.target.checked)}
                                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                                    checkedIcon={<CheckBox fontSize="small" />}
                                />
                            }
                            label="Imprimir comanda completa"
                        />
                    </Grid>
                    {isImprimirComandaCompleta ? (
                        <Grid item xs={12} md={6} lg={6}>
                            <FormControl variant="outlined" style={{ width: "100%" }}>
                                <InputLabel id="impressoras">Impr. p/ comanda completa</InputLabel>
                                <Select
                                    fullWidth
                                    value={impressoraComandaCompleta}
                                    onChange={e => setImpressoraComandaCompleta(e.target.value)}
                                    label="Impr. p/ comanda completa"
                                >
                                    <MenuItem value="Nenhuma">Nenhuma</MenuItem>
                                    {impressorasQZ.map((printer, index) => (
                                        <MenuItem key={index} value={printer}>
                                            {printer}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    ) : null}{" "}
                </>
            ) : null}
        </>
    )
}

const ListaPedidosMesa = ({
    mesa,
    setPedidoSelecionado,
    handleClose,
    useStyles,
    Transition,
    impressorasQZ,
    setImpressorasQZ,
    alertStart,
    todasMesas,
    atualizarMesas,
}) => {
    const classes = useStyles()
    const history = useHistory()

    const [openFinalizarMesa, setOpenFinalizarMesa] = useState(false)

    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const { printer } = configuracoes

    const tipoPainelImpressao = useAppStore(s => s.tipoPainelImpressao())

    const parametros = configuracoes.user.parametros
    const tipoPrinter =
        tipoPainelImpressao === "plugin"
            ? printer.tipoImpressao
                ? printer.tipoImpressao
                : "code"
            : ""
    const tamanhoFonteSelect = printer.tamanhoFonteSelect ? printer.tamanhoFonteSelect : "media"

    function getImpressoras(configuracoes) {
        if (configuracoes.printer.impressoras?.length) return configuracoes.printer.impressoras

        return []
    }

    const exibirTamanhoFonte = tipoPrinter === "html"

    const handleSelecaoPedido = e => {
        if (!mesa.pedidosMesa) return

        const pedido = mesa.pedidosMesa[e.target.dataset.index]
        setPedidoSelecionado(pedido)

        textoHTML(pedido.textoImpressao)
    }

    const verificarSeTemQZ = () => {
        try {
            if (qz.websocket.isActive()) {
                buscarImpressoras()
            } else {
                qz.websocket
                    .connect()
                    .then(() => {
                        qz.printers
                            .details()
                            .then(data => {
                                for (var i = 0; i < data.length; i++) {
                                    console.log(
                                        data[i].name +
                                            " " +
                                            data[i].driver +
                                            " " +
                                            data[i].density +
                                            " " +
                                            data[i].trays
                                    )
                                }
                            })
                            .catch(function (e) {
                                console.error(e)
                            })

                        //console.log('Conectado QZ!');
                        buscarImpressoras()
                    })
                    .catch(err => {
                        console.error("Erro QZ", err.message)
                        // alertStart("Impressao automatica não identifica!", "error")
                        if (tipoPainelImpressao === "plugin") {
                            setImpressorasQZ([])
                        }
                    })
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarSeTemQZ")
        }
    }

    const buscarImpressoras = async () => {
        try {
            // TODO:
            // if (!configuracoes.printer?.impressoras?.length) {
            //     configuracoes.printer.impressoras = [await qz.printers.getDefault()]
            //     atualizarConfiguracoes(configuracoes)
            // }

            const printers = await qz.printers.find()
            setImpressorasQZ(printers)
            //console.log('PRINTERS QZ >>>>>>> ', printers)
        } catch (error) {
            // RegistrarLogErro(error, "buscarImpressoras")
        }
    }

    const [opcoesDePagamento, setOpcoesDePagamento] = useState([])
    const buscarFormasDePagamento = async idEstabelecimento => {
        try {
            const response = await BuscarFormaDePagamentos(idEstabelecimento)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setOpcoesDePagamento(response)
        } catch (error) {
            RegistrarLogErro(error, "BuscarFormaDePagamentos")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const [pedidoEnviar, setPedidoEnviar] = useState()

    const [openPedido, setOpenPedido] = useState(false)
    const handleOpenPedido = pedido => {
        setPedidoEnviar(pedido)
        setOpenPedido(true)
    }
    const handleClosePedido = () => {
        setOpenPedido(false)
    }

    const [fullWidth, setFullWidth] = useState(true)

    const [openConfiguracoes, setopenConfiguracoes] = useState(false)
    const handleCloseConfiguracoes = () => {
        setopenConfiguracoes(false)
    }

    const [numeroMesa, setNumeroMesa] = useState(mesa?.numeroMesa)
    const handleChangeNumeroMesa = e => {
        setNumeroMesa(e.target.value)
    }

    const [mesaRenderizar, setMesaRenderizar] = useState()

    useEffect(() => {
        setNumeroMesa(mesa?.numeroMesa)
        setMesaRenderizar(mesa)
    }, [mesa])

    const mudarMesa = async numeroMesa => {
        const Authorization = localStorage.getItem("chaveSistema")
        mesa.numeroMesa = numeroMesa

        try {
            const response = await MudarNumeroMesa(mesa, Authorization)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setOpcoesDePagamento(response)
        } catch (error) {
            RegistrarLogErro(error, "excluirItemDoPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    let aberta = !(mesa && Object.keys(mesa)?.length !== 1)

    return (
        <>
            <DialogConfiguracoes
                todasMesas={todasMesas}
                parametros={parametros}
                classes={classes}
                printer={printer}
                mesa={mesa}
                openConfiguracoes={openConfiguracoes}
                handleCloseConfiguracoes={handleCloseConfiguracoes}
                numeroMesa={numeroMesa}
                handleChangeNumeroMesa={handleChangeNumeroMesa}
                tipoPainelImpressao={tipoPainelImpressao}
                atualizarConfiguracoes={atualizarConfiguracoes}
                tamanhoFonteSelect={tamanhoFonteSelect}
                exibirTamanhoFonte={exibirTamanhoFonte}
                tipoPrinter={tipoPrinter}
                ListaImpressorasSelecionadas={ListaImpressorasSelecionadas}
                impressorasQZ={impressorasQZ}
                mudarMesa={mudarMesa}
                verificarSeTemQZ={verificarSeTemQZ}
            />
            <Dialog
                TransitionComponent={Transition}
                fullScreen
                open={!!mesa?.numeroMesa}
                onClose={handleClose}
            >
                <CabecalhoMesa classes={classes} mesa={mesa} handleClose={handleClose} />
                <DialogFinalizarMesa
                    mesa={mesa}
                    handleClose={handleClose}
                    openFinalizarMesa={openFinalizarMesa}
                    setOpenFinalizarMesa={setOpenFinalizarMesa}
                    Transition={Transition}
                    alertStart={alertStart}
                    useStyles={useStyles}
                    opcoesDePagamento={opcoesDePagamento}
                />
                <div className={classes.barraControle}>
                    <IconButton
                        size="small"
                        onClick={() => {
                            setopenConfiguracoes(true)
                        }}
                    >
                        <Settings />
                    </IconButton>
                </div>
                <Grid container spacing={1} className={classes.containerCardPedido}>
                    {mesaRenderizar?.pedidosMesa
                        ? mesaRenderizar?.pedidosMesa.map((pedido, index) => (
                              <Grid container item key={index} xs={12} sm={6} md={3}>
                                  <CardPedido
                                      mesa={mesa}
                                      alertStart={alertStart}
                                      pedidoEnviar={pedido}
                                      handleClosePedido={handleClosePedido}
                                      atualizarMesas={atualizarMesas}
                                      classes={classes}
                                      index={index}
                                      setMesaRenderizar={setMesaRenderizar}
                                  ></CardPedido>
                              </Grid>
                          ))
                        : null}
                </Grid>
                <Fab
                    disabled={aberta}
                    variant="extended"
                    aria-label="add"
                    className={classes.botaoEstaticoClose}
                    onClick={async () => {
                        await buscarFormasDePagamento(mesa?.estabelecimento?.id)
                        setOpenFinalizarMesa(true)
                    }}
                >
                    <Check />
                    Detalhes da mesa
                </Fab>
                <Fab
                    variant="extended"
                    aria-label="add"
                    className={classes.botaoEstaticoAdd}
                    onClick={() =>
                        history.push(
                            "/servicos/modulo/registrador-de-pedidos?mesa=" + mesa.numeroMesa
                        )
                    }
                >
                    <Add />
                    Adicionar Pedido
                </Fab>
            </Dialog>
        </>
    )
}

export default ListaPedidosMesa
